import { render, staticRenderFns } from "./MotivationInfo.vue?vue&type=template&id=81e6d8ba&scoped=true"
import script from "./MotivationInfo.vue?vue&type=script&lang=js"
export * from "./MotivationInfo.vue?vue&type=script&lang=js"
import style0 from "./MotivationInfo.vue?vue&type=style&index=0&id=81e6d8ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e6d8ba",
  null
  
)

export default component.exports